// Props down, events up으로 기능구현이 불가능한 경우 컴포넌트간의 event 전달에 사용.
import Vue from 'vue'
const EventBus = new Vue()
export default EventBus
